
import { LegionExposeData } from 'src/components/adminAchive/useLoadLegionExpose';
import { PromoterAnalysiseData } from 'src/components/adminAchive/useLoadPromoterAnalysis';
import { SchoolAnalysiseData } from 'src/components/adminAchive/useLoadSchoolAnalysis';
import { TeamAnalysisData } from 'src/components/adminAchive/useLoadTeamAnalysis';
import { PromoListData } from 'src/components/adminPromo/useLoadPromoList';
import { create } from 'zustand';

interface AdAchiveState{
    start_date: Date|null,
    end_date: Date|null,
    legionExposeData: LegionExposeData[],
    promoterAnalysisData : PromoterAnalysiseData[]
    wide_Loc : string | null
    city_Loc : string | null
    schoolAnalysisDate : SchoolAnalysiseData[],
    promoListData : PromoListData[]
    teamAnalysisData : TeamAnalysisData[]
    setField : (field: keyof AdAchiveState, value: any) => void 
    reset : ()=>void
}

const defaultValue = {
    start_date : null,
    end_date:null,
    legionExposeData : [],
    promoterAnalysisData : [],
    wide_Loc : null,
    city_Loc : null,
    schoolAnalysisDate:[],
    promoListData:[],
    teamAnalysisData:[]
}

export const useAdAchiveStore = create<AdAchiveState>((set)=>({
    ...defaultValue,
    setField : (field,value)=>set((state)=>({...state,[field]:value})),
    reset : ()=>set({...defaultValue})
}))